import {
    CommonPlayLogicWithTextEditor,
} from '@src/slide/content-viewer/service/canvas-renderer/entry/player/logic/common-play-logic-with-text-editor';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ComponentFactory } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/component-factory';
import { PointerEvents } from '@tencent/alloy-renderer';
import { ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';

export class TablePlayerLogic extends CommonPlayLogicWithTextEditor {
    public constructor(factoryOptions: InterfaceFactoryOptions<ITableModel>, component: ComponentFactory) {
        super(factoryOptions, component);

        // 渲染层表格默认禁掉事件以提高渲染性能，编辑区单独附加事件component来响应事件
        // player下操作比较简单，直接将背景和边框的事件打开即可，不再单独加事件响应component
        if (component.inner.tableBackground) {
            component.inner.tableBackground.pointerEvents = PointerEvents.AUTO;
        }
        if (component.inner.tableBorder) {
            component.inner.tableBorder.pointerEvents = PointerEvents.AUTO;
        }
    }
}
